import type { AnnouncementRepresentation } from "../types";
import { useState } from "#imports";

export const useAnnouncementDataState = () => useState<AnnouncementRepresentation[]>( "announcements", () => [] );
